import React from 'react';
import { Image } from 'react-native';

// Web shim for react-native-fast-image — falls back to RN Image
const FastImage = React.forwardRef(function FastImage({ source, style, resizeMode, onLoad, onError, children, ...props }, ref) {
  const src = typeof source === 'object' ? source : { uri: source };
  return React.createElement(Image, { ref, source: src, style, resizeMode, onLoad, onError, ...props }, children);
});

FastImage.resizeMode = { contain: 'contain', cover: 'cover', stretch: 'stretch', center: 'center' };
FastImage.priority = { low: 'low', normal: 'normal', high: 'high' };
FastImage.cacheControl = { immutable: 'immutable', web: 'web', cacheOnly: 'cacheOnly' };
FastImage.preload = () => {};
FastImage.clearMemoryCache = () => Promise.resolve();
FastImage.clearDiskCache = () => Promise.resolve();

export default FastImage;
